// Only GATSBY_-prefixed env vars are inlined in the browser bundle
export const hasAppV2 = () => process.env.GATSBY_HAS_APP_V2 === "true"
